var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 149,
    viewBox: "0 0 268 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.28 53.6912C267.28 61.3409 256.958 67.516 244.239 67.516C231.52 67.516 221.197 61.3409 221.197 53.6912C221.197 46.0414 231.52 39.8663 244.239 39.8663C256.958 39.8663 267.28 46.0414 267.28 53.6912Z",
    fill: "#FFAA54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 53.6912C0 61.3409 10.3226 67.516 23.0415 67.516C35.7604 67.516 46.083 61.3409 46.083 53.6912C46.083 46.0414 35.7604 39.8663 23.0415 39.8663C10.3226 39.8663 0 46.0414 0 53.6912Z",
    fill: "#FFAA54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60938 19.129C4.60938 14.8513 6.30868 10.7489 9.33346 7.72409C12.3582 4.69931 16.4607 3 20.7384 3C25.0161 3 29.1186 4.69931 32.1434 7.72409C35.1681 10.7489 36.8674 14.8513 36.8674 19.129",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.414 19.129C230.414 14.8513 232.113 10.7489 235.138 7.72409C238.163 4.69931 242.265 3 246.543 3C250.821 3 254.923 4.69931 257.948 7.72409C260.973 10.7489 262.672 14.8513 262.672 19.129",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.635 146.318C218.428 146.318 229.764 110.926 224.787 81.8017C223.718 77.4491 221.731 73.3755 218.958 69.8542C216.186 66.3329 212.692 63.4453 208.711 61.3853C204.731 59.3252 200.356 58.1403 195.88 57.9101C191.404 57.6799 186.93 58.4097 182.76 60.0506C166.924 65.3224 150.325 67.9384 133.635 67.7925C116.946 67.9384 100.347 65.3224 84.5109 60.0506C80.3401 58.4097 75.8667 57.6799 71.3907 57.9101C66.9147 58.1403 62.5397 59.3252 58.5592 61.3853C54.5788 63.4453 51.085 66.3329 48.3123 69.8542C45.5396 73.3755 43.5521 77.4491 42.4832 81.8017C37.5063 110.926 48.8427 146.318 133.635 146.318Z",
    fill: "white",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.618 88.5302C212.146 94.6819 197.873 98.9017 183.222 101.065C166.828 103.705 150.242 104.969 133.637 104.844C117.032 104.969 100.446 103.705 84.0516 101.065C69.4002 98.9017 55.1274 94.6819 41.6553 88.5302",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1414 61.8942L84.0584 101.065L78.252 138.761",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.643 146.318V67.9768",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.24 61.8942L183.231 101.065L189.037 138.761",
    stroke: "#45413C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearBg);
export default __webpack_public_path__ + "static/media/clear-bg.f5343149c0112d967279e6377479110b.svg";
export { ForwardRef as ReactComponent };